export default __webpack_public_path__ + "static/media/NotoSans-Light.8b7f0378.woff";